<template>
  <Admin>
    <v-main>
      <v-container fluid>
        <v-row justify="center" style="margin-bottom: 20px;">
          <v-col>
            <document-table :data="displayedItems" :current-page="currentPage"></document-table>
          </v-col>
        </v-row>


        <!-- Month-Year Select Row -->


        <v-row justify="start" class="tw-my-4">
          <v-col>
            <select class="items-per-page-selector" v-model="itemsPerPage">
              <option v-for="option in itemsPerPageOptions" :key="option" :value="option"
                :selected="option === itemsPerPage">
                {{ option }}
              </option>
            </select>
          </v-col>
          <v-col>
            <v-pagination v-model="currentPage" :length="numPages" :total-visible="10" @input="paginate"></v-pagination>
          </v-col>
          <v-col class="tw-flex tw-items-end tw-justify-end">
            <p class="total-item">จำนวนเอกสารทั้งหมด: {{ totalItems }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </Admin>
</template>

  <script>
    import { mapState, mapActions } from "vuex";
    import Admin from "../../components/admin/admin-main-template";
    import DocumentTable from "../../components/admin/documents/table.tax.vue";

    export default {
    name: "taxSales",
    components: {
    Admin,
    DocumentTable,
    // PaginationWithKeyword,
  },
  data() {
    return {
      itemsPerPage: 10,
      currentPage: 1,
      displayedItems: [],
      itemsPerPageOptions: [10, 20, 30, 40, 50],
      MountYearMenu: false,
      MountYearVal: null,
      selectedTaxType: null,
      months: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
      years: [2023, 2024, 2025],
      taxPeriods: ['2023', '2024', '2025'],
      selectedMonthYear: null,
      monthYearOptions: [],
    }
  },
  computed: {
    ...mapState({
      docs: (state) => state.thaismartTaxDetail.list,
      keyword: (state) => state.thaismartTaxDetail.keyword,
      // summaryAll: (state) => state.thaismartTax.summaryAll,
      MountYearDisp() {
        return this.MountYearVal;
  },
    }),
    numPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    totalItems() {
      return this.docs.length;  
    },
  },
  methods: {
    ...mapActions({
      resetKeyword: "thaismartTaxDetail/resetKeyword",
      setSelectedList: "thaismartTaxDetail/setSelectedList",
    }),
    paginate() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      // 0010 remove padding
      const endIndex = Number.parseInt(startIndex) +  Number.parseInt(this.itemsPerPage);
      // const endIndex = startIndex + this.itemsPerPage;
      this.displayedItems = this.docs.slice(startIndex, endIndex);
      // debugger;
      // console.log("displayedItems", this.displayedItems.length);
    },
  },
  beforeRouteLeave(to, from, next) {
    // console.log("current", from.path, '->', to.path);
    this.resetKeyword();
    this.setSelectedList({ selectedList: [] });
    next();
  },
  watch: {
    defaultSearchOptionValue: {
      handler: function () {
        this.MountYearVal = null;
      },
    },
    docs: {
      handler() {
        this.paginate();
      },
      immediate: true,
    },
    itemsPerPage() {
      this.paginate();
    },
    currentPage() {
      this.paginate();
    },
  },
  mounted() {
    this.itemsPerPage = Number.isNaN(Number.parseInt(localStorage.getItem("pageLimit"))) ? 10 : Number.parseInt(localStorage.getItem("pageLimit"))
    // this.generateMonthYearOptions()
  },

};
</script>
<style scoped   >
.items-per-page-selector {
  padding: 0.3rem .5rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.v-text-field fieldset,
  .v-text-field .v-input__control,
  .v-text-field .v-input__slot {
   border-radius: 10px !important;
    border-color: #c4c4c4;
    margin-top: 5px;
    margin-bottom: 5px;
    /* //width: 270px; */

  }

</style>
